import { normalizeText } from '../selectSearchFilter';

export const MIN_MUNICIPIO_QUERY_LENGTH = 3;
export const MUNICIPIO_RESULT_LIMIT = 50;

export function getMunicipioNoOptionsMessage(inputValue) {
  const trimmed = (inputValue ?? '').trim();

  if (!trimmed) {
    return 'Digite para pesquisar';
  }

  if (trimmed.length < MIN_MUNICIPIO_QUERY_LENGTH) {
    return 'Digite ao menos 3 caracteres';
  }

  return 'Nenhum município encontrado';
}

export function matchesMunicipioQuery(searchKey, query) {
  return Boolean(query) && searchKey.includes(query);
}

export function scoreMunicipioMatch(searchKey, query) {
  if (!query) {
    return 0;
  }

  if (searchKey === query) {
    return 100;
  }

  if (searchKey.startsWith(query)) {
    return 80 - searchKey.length * 0.01;
  }

  const words = searchKey.split(/\s+/);
  if (words.some((word) => word.startsWith(query))) {
    return 50 - searchKey.length * 0.01;
  }

  if (searchKey.includes(query)) {
    return 20;
  }

  return 0;
}

export function filterMunicipioOptions(
  options,
  inputValue,
  { limit = MUNICIPIO_RESULT_LIMIT } = {}
) {
  const query = normalizeText(inputValue?.trim());

  if (!query || query.length < MIN_MUNICIPIO_QUERY_LENGTH) {
    return [];
  }

  return options
    .filter((option) => matchesMunicipioQuery(option.searchKey, query))
    .sort((a, b) => {
      const scoreDiff = scoreMunicipioMatch(b.searchKey, query)
        - scoreMunicipioMatch(a.searchKey, query);

      if (scoreDiff !== 0) {
        return scoreDiff;
      }

      return a.searchKey.localeCompare(b.searchKey, 'pt-BR');
    })
    .slice(0, limit);
}
